module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-history-selected@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-history-selected@1x.png
// module id = 626
// module chunks = 0